import { useParams } from "react-router-dom";

export const NassSanAntonio = () => {
  const { id } = useParams();
  const path = '/newsletter/versions/nass_san_antonio.html';
  return (
    <iframe
      title={"NASS San Antonio"}
      src={path}
      style={{ width: "100vw", height: "100vh" }}
    />
  );
};
